import React from "react";

const ContactDetails = ({ eventData, setEventData }) => {
   const today = new Date().toISOString().split("T")[0];
  return (
    <>
      <div className="">
      <h2 className="main-head">Contact Details</h2>
      <p className="layout-text">
        To avoid vendors contacting you without your consent, we will not share
        your contact details with any vendor until you choose to work with them.       
      </p>

      <div className="form-holder">
        <form>
          <div className="form-items">
            <label className="form-label">Full Name/Alias</label>
            <input
              type="text"
              id="name"
              name="name"
              placeholder="Full Name or Alias"
              value={eventData.name}
              //   className={errors.name ? "error-input" : ""}
              onChange={(e) =>
                setEventData({ ...eventData, name: e.target.value })
              }
            />
            {/* {errors.name && (
              <span className="error-text">{errors.businessName}</span>
            )} */}
          </div>

          <div className="form-items">
            <label className="form-label">Phone Number</label>
            <input
              type="number"
              name="phone"
              placeholder="0801234......"
              value={eventData?.phone || ""}
              onChange={(e) =>
                setEventData({ ...eventData, phone: e.target.value })
              }
            />
            {/* {errors.phone && <span className="error-text">{errors.phone}</span>} */}
          </div>
          <div className="form-items">
            <label className="form-label">Email</label>
            <input
              type="email"
              name="email"
              placeholder="yourname@example.com"
              value={eventData?.email || ""}
              onChange={(e) =>
                setEventData({ ...eventData, email: e.target.value })
              }
            />
            {/* {errors.email && <span className="error-text">{errors.email}</span>} */}
          </div>
        </form>
      </div>

        <h3 className="sub-layout-text mt-5">
         One more thing....
      </h3>


      <div className="form-holder">
        <form>
          <div className="form-items">
            <label className="form-label">What is the deadline for vendors to submit their offers?</label>
            <div className="date-picker-wrapper">
                  <input
                    type="date"
                    id="deadlineDate"
                    name="deadlineDate"
                    min={today}
                    placeholder="Select A Date"
                    value={eventData.deadlineDate || ""}
                    //   className={errors.deadlineDate ? "error-input" : ""}
                    className="custom-date-input"
                    onChange={(e) =>
                      setEventData({ ...eventData, deadlineDate: e.target.value })
                    }
                  />
                </div>
               
          </div>
        </form>
      </div>

      <div class="warning-message">
              <p>
                We charge a <strong>₦1,000 listing fee</strong> to ensure only genuine requests reach our trusted vendors. If no vendor applies to your request within your set response period, your payment is automatically refunded as Quickplanners Credit, which you can use for another listing anytime.</p>
            </div>
    </div>
    
    </>
  );
};

export default ContactDetails;
